import { render, staticRenderFns } from "./_head.vue?vue&type=template&id=7a36c2ea&"
import script from "./_head.vue?vue&type=script&lang=js&"
export * from "./_head.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports